export const AUTH_TYPE_BASIC = "Basic ";
export const AUTH_TYPE_BEARER = "Bearer ";
export const AUTH_TOKEN = "X-Auth-Token";